module.exports = __webpack_public_path__ + "img/42.7a4cab51.jpg";